import {
    ClientBillingRobokassaCheckoutEntity,
    ClientBillingRobokassaCheckoutInputEntity,
    ClientBillingSummaryEntity,
    ClientBillingTestPaymentInputEntity,
} from '@/entities/client-billing.entity';
import { EndpointOptions } from '@/types/endpoint.options';
import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import { buildMarketplaceApiPath } from '@/repositories/marketplace-api-paths';

type ClientBillingTestPaymentPayload = Omit<ClientBillingTestPaymentInputEntity, 'clientId'>;
type ClientBillingRobokassaCheckoutPayload = Omit<ClientBillingRobokassaCheckoutInputEntity, 'clientId'>;

class ClientBillingRepository {
    private readonly _testPaymentAxios = getAxiosInstance(buildMarketplaceApiPath('settings/billing/test-payment'));
    private readonly _robokassaCheckoutAxios = getAxiosInstance(
        buildMarketplaceApiPath('settings/billing/robokassa/checkout'),
    );

    createTestPayment(data: ClientBillingTestPaymentPayload, options?: EndpointOptions) {
        return this._testPaymentAxios.post<ClientBillingSummaryEntity>(
            '',
            data,
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }

    createRobokassaCheckout(data: ClientBillingRobokassaCheckoutPayload, options?: EndpointOptions) {
        return this._robokassaCheckoutAxios.post<ClientBillingRobokassaCheckoutEntity>(
            '',
            data,
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }
}

export const createClientBillingRepository = () => new ClientBillingRepository();

export const clientBillingRepository = createClientBillingRepository();
